var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 12,
    viewBox: "0 0 87 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51514 4.38885C2.82663 6.7204 8.95007 9.31715 11.3935 7.4167C13.8509 5.50541 14.8955 3.70759 18.2062 3.70759C20.5647 3.70759 22.5271 3.65922 24.716 4.38885C29.6943 6.04827 31.4779 9.21059 37.2438 7.11392C39.233 6.39055 39.5015 5.07012 42.0883 5.07012C44.8513 5.07012 46.3128 4.82856 48.2197 6.73544C49.1044 7.62011 51.3687 9.76596 52.6101 9.83898C55.7564 10.0241 55.4609 10.4647 57.5304 6.96253C60.914 1.23637 64.0912 -0.0856249 68.9605 5.07012C71.8552 8.1351 74.3468 7.1865 77.2871 4.54025C80.2449 1.87821 82.8184 7.57083 84.6296 8.47645",
    stroke: "#DA494C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.1db88b86079c5de79747c35752f32be2.svg";
export { ForwardRef as ReactComponent };